import { render, staticRenderFns } from "./DeckMap.vue?vue&type=template&id=06252127"
import script from "./DeckMap.vue?vue&type=script&lang=js"
export * from "./DeckMap.vue?vue&type=script&lang=js"
import style0 from "./DeckMap.vue?vue&type=style&index=0&id=06252127&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports